<template>
  <v-select
    v-model="status"
    :items="page.statuses"
    label="Status"
    outlined
    hide-details
  />
</template>

<script>
import { computed, onMounted, reactive, set } from "@vue/composition-api";
import compact from "lodash/compact";
import isEqual from "lodash/isEqual";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

const SUPPORTED_STATUSES = {
  publish: "Publié",
  draft: "Brouillon",
};

export default {
  name: "StatusFilter",
  components: {},
  props: {
    initialValue: {
      type: Number,
      validator(value) {
        return !isNaN(value);
      },
    },
    store: {
      type: String,
      validator(value) {
        /* List of stores having :
        - getters["<store>/<storeGetter>"]
        - dispatch("<store>/<storeUpdater>", payload)
        */
        return ["aiFactory"].includes(value);
      },
    },
    storeGetter: {
      type: String,
      default: "getPublicationStatus",
    },
    storeUpdater: {
      type: String,
      default: "updatePublicationStatus",
    },
    noUrl: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { axiosGet } = useAxios();
    const { store } = useProxy();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const page = reactive({
      isInitialized: false,
      initialUrlValue: "", // in case we need to load from url params
      statuses: [],
    });

    // =>  METHODS

    // =>  COMPUTED
    const viaStore = computed(() => props.store !== undefined);
    const initialValue = computed(() =>
      props.noUrl
        ? props.initialValue
        : page.initialUrlValue ?? props.initialValue
    );

    const status = computed({
      get: () => {
        if (viaStore.value) {
          return store.getters[`${props.store}/${props.storeGetter}`];
        }

        return initialValue.value;
      },
      set: (value) => {
        if (viaStore.value) {
          store.dispatch(`${props.store}/${props.storeUpdater}`, value);

          if (page.isInitialized && !props.noUrl) {
            // Only update user changes, not initialization
            addQueryStringParam({
              param: "status",
              value: value,
              // is_multiple: false,
              // is_integer: false,
              // is_boolean: false,
            });
          }
        }

        if (!isEqual(value, initialValue.value)) {
          emit("valueChanged", value);
        }
      },
    });

    // =>  WATCH

    // =>  HOOKS
    onMounted(async () => {
      const {
        data: { items },
      } = await axiosGet("/meta-options/aif_publication_status/");
      page.statuses = compact(
        Object.entries(SUPPORTED_STATUSES).map(([status, text]) => {
          const item = items.find((i) => i.name === status);
          if (item === undefined) {
            return undefined;
          }

          return {
            value: item.id,
            text,
          };
        })
      );

      if (viaStore.value && !props.noUrl) {
        set(
          page,
          "initialUrlValue",
          await synchronizeFilterWithQueryString({
            dispatcher: "aiFactory/updatePublicationStatus",
            param: "status",
            value: status.value,
            // is_multiple: false,
            // is_integer: false,
            // is_boolean: false,
            // dependsOn: undefined,
          })
        );
      }

      page.isInitialized = true;
    });

    // =>  DATA
    return {
      page,
      status,
    };
  },
};
</script>

<style></style>
